import { Address } from '../../types/Address'

const formatAddress = (address?: Address): string => {
  return `${address?.street}, ${address?.number}${
    address?.complement ? `, ${address?.complement}` : ''
  } - ${address?.neighborhood}, ${address?.city}/${address?.state} - ${address?.zipcode}`
}

export { formatAddress }
